import qs from 'qs';
import { setCookie } from 'utils/bom-dom-manipulation/cookies';
import { CookieExpiration } from 'utils/constants/dateInfo/dateInfo';

export const btagDetection = () => {
  const searchParams = qs.parse(window.location.search, {
    ignoreQueryPrefix: true
  });

  let btag = '';

  if (searchParams.btag) {
    btag = String(searchParams.btag);
  } else if (window.location.hash.includes('btag')) {
    btag = window.location.hash.split('btag=')?.[1]?.split('&')?.[0];
  }

  if (btag) {
    setCookie('btag', String(btag), CookieExpiration.DAYS_30, {
      SameSite: 'None',
      Secure: true
    });
  }

  if (searchParams.loyalty_code) {
    setCookie(
      'loyalty_code',
      String(searchParams.loyalty_code),
      CookieExpiration.DAYS_30,
      {
        SameSite: 'None',
        Secure: true
      }
    );
  }

  let agentId = '';

  if (searchParams.agentId) {
    agentId = String(searchParams.agentId);
  } else if (window.location.hash.includes('agentId')) {
    agentId = window.location.hash.split('agentId=')?.[1]?.split('&')?.[0];
  }

  if (agentId) {
    setCookie('agentId', String(agentId), CookieExpiration.DAYS_30, {
      SameSite: 'None',
      Secure: true
    });
  }

  if (searchParams.reference_code) {
    setCookie(
      'reference_code',
      String(searchParams.reference_code),
      CookieExpiration.DAYS_30,
      {
        SameSite: 'None',
        Secure: true
      }
    );
  }
};
